// extracted by mini-css-extract-plugin
export default {"flightCardBadges":"FlightCardBadges-module__flightCardBadges___sgx__"};